/* eslint-disable no-prototype-builtins */

/**
 * Converts all Null values of an object into Undefined values to be used as a payload in a POST request.
 *
 * @param object - The object that will be as a payload.
 * @returns Object
 */
export function formatDataForPostRequest(
    object: Record<string, any>
): Record<string, any> {
    let formattedValues = {};

    for (const key in object) {
        if (object.hasOwnProperty(key)) {
            let value = object[key];

            if (value === null) {
                value = undefined;
            }

            formattedValues = { ...formattedValues, [key]: value };
        }
    }

    return formattedValues;
}
